import { managerFactory } from "@/factories/manager";
import { initializeDatadogLoggingClient } from "@/manager/datadog-logging-client/initializeDatadogLoggingClient";

export const datadogLoggingClientManager = managerFactory.create({
  initializer: initializeDatadogLoggingClient,
});
